import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class TicketWinStatusRequest extends ApiGetRequest
{
    public constructor(ticketNumber: number, numberOfDraws: number, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('ticketnumber', ticketNumber)
            .addQueryParameter('numberOfDraws', numberOfDraws);

        super('ticketwinstatus', parameters, null, webapiBasepath);
    }
}
